import { UserQuelleAllgemein } from './user-quelle-allgemein.model';

export class UserQuelleStall extends UserQuelleAllgemein {
  idUserQuelleStall: number;
  idMmTierartenZuord: number;
  wirkungsgrad: number;
  quellenspezZusatzabstand: number;
  idTierart: number;
  idTierkategorie: number;
  idTkHvGeruchsemissionZuord: number;
  anzahlTiere: number;
}
